import { Box, List, ListItemButton, ListItemText, Divider, Typography } from '@mui/material';

export default function AdminSidebar({ activeTab, onChangeTab }) {
  // ✅ fallback để không bị "not a function"
  const changeTab = typeof onChangeTab === 'function' ? onChangeTab : () => {};

  return (
    <Box
      sx={{
        width: 220,
        borderRight: '1px solid #eee',
        height: '100vh',
        position: 'sticky',
        top: 0,
        bgcolor: '#fff',
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          MCPE Web Tool
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Internal Admin
        </Typography>
      </Box>

      <Divider />

      <List>
        <ListItemButton selected={activeTab === 'home'} onClick={() => changeTab('home')}>
          <ListItemText primary="Home page" />
        </ListItemButton>

        <ListItemButton selected={activeTab === 'addons'} onClick={() => changeTab('addons')}>
          <ListItemText primary="Addon Manager" />
        </ListItemButton>

        <ListItemButton selected={activeTab === 'skins'} onClick={() => changeTab('skins')}>
          <ListItemText primary="Skin Manager" />
        </ListItemButton>
      </List>
    </Box>
  );
}
